import cn from "classnames";
import { dateToView } from "helpers/date";
import { bidCalculationStatuses, bidCalculationStatusesEnum } from "helpers/enums";
import { bidPointLoadUnloadStatuses } from "helpers/enums/bidPointLoadUnloadStatuses";
import { bidStatuses, bidStatusesEnum } from "helpers/enums/bidStatuses";
import Tooltip from "rc-tooltip";
import React from "react";

function renderStatus({ status, ...bid }, organization) {
    if (bid.isDeleted) {
        return <span className="badge badge-dark">Удалена</span>;
    }
    let statusObj = bidStatuses.find((item) => item.value === status);
    let cname = cn("badge", {
        "badge-light": status === bidStatusesEnum.New,
        "badge-primary": status === bidStatusesEnum.Started,
        "badge-secondary": status === bidStatusesEnum.Canceled,
        "badge-success": status === bidStatusesEnum.Done,
    });
    const { bidPointLoadUnloadStatus, isEmptyMileageBid, approvedAt, createdBy, isPreBid } = bid;
    if (status === bidStatusesEnum.Started) {
        if (bid.calculationStatus) {
            cname =
                bid.calculationStatus === bidCalculationStatusesEnum.InProgress
                    ? "badge badge-info"
                    : "badge badge-danger";
            statusObj = bidCalculationStatuses.find((item) => item.value === bid.calculationStatus);
        } else if (bidPointLoadUnloadStatus) {
            cname = "badge badge-info";
            statusObj = bidPointLoadUnloadStatuses.find((item) => item.value === bidPointLoadUnloadStatus);
        }
    }

    return (
        <div className="show-bid__head-status">
            <span className={cname}>{statusObj && statusObj.label}</span>
            {isPreBid && <span className="badge badge-secondary">Предзаявка</span>}
            {status === bidStatusesEnum.New && bid.showDraftInPlanning && (
                <span className="badge badge-info">Отображается в планировании</span>
            )}
            {isEmptyMileageBid && <span className="badge badge-warning">Порожняя</span>}
            {organization.usesBidsApproval &&
                !isEmptyMileageBid &&
                status === bidStatusesEnum.New &&
                createdBy &&
                createdBy.isOperator &&
                (approvedAt ? (
                    <span className="badge badge-success">Согласована</span>
                ) : (
                    <span className="badge badge-warning">Не согласована</span>
                ))}
        </div>
    );
}

const BidHead = ({ bid, id, back, bidPolicy, organization }) => {
    let bidTitle = `Заявка №${id}`;
    let bidStatus = renderStatus(bid, organization);
    if (bidPolicy.isOpened()) {
        bidTitle = bidPolicy.isMyBid() ? "Моя ставка" : `Открытая заявка №${id}`;
        bidStatus = <div className="show-bid__head-date">{dateToView(bid.createdAt)}</div>;
    }
    const { externalId, isExpressBid, hasItemsChange } = bid;
    return (
        <div className="show-bid__head">
            <div className="show-bid__head-close close close--sm" onClick={back} />
            <div className="show-bid__head-title">
                {bidTitle}
                {isExpressBid && (
                    <Tooltip overlayClassName="show-bid__head--tooltip" overlay="Экспресс-заявка" placement="bottom">
                        <small className="pl-1 icon-uEA90-bolt b-point__tooltip-icon" />
                    </Tooltip>
                )}
                {externalId && (
                    <Tooltip overlayClassName="show-bid__head--tooltip" overlay={externalId} placement="bottom">
                        <small className="text-muted pl-1">({externalId})</small>
                    </Tooltip>
                )}
                {hasItemsChange && (
                    <Tooltip
                        overlayClassName="show-bid__head--tooltip"
                        overlay="В заявке была осуществлена перецепка/пересменка"
                        placement="bottom"
                    >
                        <small className="text-muted pl-1 icon-uEAB3-arrows-rotate" />
                    </Tooltip>
                )}
            </div>
            {bidStatus}
        </div>
    );
};

export default BidHead;
